import { PayloadAction } from '@reduxjs/toolkit'
import { TProductFilters } from '../../../models'

const removeCategories = (
  state: TProductFilters[],
  action: PayloadAction<{
    id: number
  }>
) => {
  const selectedFilters = state.find((item) => item.id === action.payload.id)

  if (selectedFilters) {
    delete selectedFilters.filters.categories
  }
}

export default removeCategories
